import Radium from 'radium';

export const SwapPageStyles = {
    animation: 'x .3s ease-in 0s 1',
    animationName: Radium.keyframes(
        {
            '0%': {
                transform: 'translate3d(-100%,0,0)'
            },
            '100%': {
                transform: 'translate3d(0,0,0)'
            }
        },
        'pulse'
    )
};
